import { useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Link, useNavigate } from 'react-router-dom';
import { PopularGroupItem, PopularGroupList } from '../../component/group';
import { Button, Space, SearchBar, Swiper, FloatingBubble } from 'antd-mobile';
import styles from './index.module.scss';
import categoryManager from '../../objects/category/manager';
import articleManager from '../../objects/article/manager';
import { ICategory } from '../../objects/category/types';
import icon from '../../assets/image/groub.png';
import { OrderShortType } from '../../types';

categoryManager.setSorter('sort_num');
categoryManager.setOrder(OrderShortType.Descend);
categoryManager.setFetchAll(true);
categoryManager.list();

articleManager.setSorter('sort_num');
articleManager.setOrder(OrderShortType.Descend);

articleManager.initList();

const Home = observer(() => {
  const navigate = useNavigate();
  const tabList = useMemo(() => {
    if (!categoryManager.data || categoryManager.data.length === 0) {
      return [];
    }

    const result: ICategory[][] = [];
    for (let i = 0; i < categoryManager.data.length; i += 10) {
      result.push(categoryManager.data.slice(i, i + 10));
    }
    return result;
  }, [categoryManager.data]);
  const [searchStr, setSearchStr] = useState<string>('');

  const items = useMemo(() => {
    return tabList.map((tabItem, index) => (
      <Swiper.Item key={index}>
        <div className={styles.swiperItem}>
          <div className={styles.content}>
            {tabItem.map((category) => {
              return (
                <div
                  className={styles.swiperSlide}
                  role="group"
                  aria-label="23 / 33"
                  // style="width: 85.2px; margin-right: 1px;"
                >
                  <Link
                    to={`/category/${category.id}?title=${encodeURIComponent(
                      category.title,
                    )}`}
                  >
                    <img src={category.cover || icon} />
                    <p>{category.title}</p>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </Swiper.Item>
    ));
  }, [tabList]);

  return (
    <div>
      <div className="p-4">
        <SearchBar
          value={searchStr}
          onChange={(value) => {
            setSearchStr(value);
          }}
          onSearch={() => {
            setSearchStr('');
            navigate(`/search?search=${encodeURIComponent(searchStr)}`);
          }}
          placeholder="请输入搜索内容"
          style={{ '--background': '#ffffff' }}
        />
      </div>
      <Swiper>{items}</Swiper>
      <div className="px-4 mt-6">
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-lg font-semibold">热门群聊</h2>
          {/* <button className="text-orange-500 text-sm">换一批</button> */}
        </div>

        <PopularGroupList
          groups={articleManager.allList}
          hasMore={articleManager.hasMore}
          loadMore={() => articleManager.loadMore()}
        />
      </div>
      <FloatingBubble
        style={{
          '--initial-position-bottom': '300px',
          '--initial-position-right': '4px',
          '--edge-distance': '24px',
          '--background': '#777777d6',
        }}
        onClick={() => {
          navigate('/complain');
        }}
      >
        投诉
      </FloatingBubble>
    </div>
  );
});

export default Home;
